import { createContext, useContext } from 'react';

export const EntityScopeContext = createContext(null);
export const useEntityScope = () => useContext(EntityScopeContext);
